import Vue from 'vue';
import ExperienceGold from '@/store/Fission/module/experience-gold';

export default {
	namespaced: true,
	modules: {
		ExperienceGold,
	},
	state: () => ({
		pageInfo: {
			posterMsg: {
				inviteCode: '',
				name: '',
			},
			inviteInfo: {},
			cashReward: {
				invitedUser: [],
			},
			task: {},
			diagram: {
				user_info: {},
			},
			weChatNum: '',
			shareAB: 'c',
			shareTxt: '',
			cycleReward: {
				invite_count: 0,
				reward_now: 0,
				cycle_invite_max: 0,
				listen_time: 0,
				reward_config: [],
			},
			limitRewardAB: -1,
			cashRewardLteInfo: {},
			remainTime: 0,
			fissionPageAb: '',
		},
		recordPageInfo: {
			myReward: {
				direct: {},
				indirect: {},
			},
			posterMsg: {
				inviteCode: '',
				name: '',
			},
		},
		modal: {},
		leaveWay: {
			name: null, // 离开操作发生位置名称； 'link': 裂变h5页面 'tab': task任务页分享赚钱裂变组件;
			param: null, // 离开页面操作参数，与 name 对应；
			isNewTab: false, // 是否为新的 tab 组件；
		},
		firstInviteByDay: {
			// 每日首邀
			is_valid: 0, // 0 不展示 1展示
			count_down: '', // 倒计时
			reward_type: 'balance', // 奖励类型
			reward_amount: 500, // 奖励金额
			need_invite_num: 1, // 需要邀请的人数
			button_open_text: '立领5元', // 开启弹窗文案
			button_success_text: '再赚8元', // 成功弹窗文案
		},
		firstInviteCountDown: {
			countDownHours: '00',
			countDownMinutes: '00',
			countDownSeconds: '00',
		},
	}),
	mutations: {
		setFissionPageInfo(state, data) {
			const {
				user_info: { invite_code: inviteCode, nickname },
				invite_info: { invite_count: inviteInfo },
				fission_balance_reward: {
					invited_user: invitedUser,
					show,
					title,
					subtitle,
					finish_status: fissionStatus,
					not_reward_num: notRewardNum,
				},
				task_list: task,
				fission: diagram,
				copy_text: weChatNum,
				share_ab: shareAB,
				share_txt: shareTxt,
				cycle_reward: cycleReward,
				cash_reward_lte_ab: limitRewardAB,
				cash_reward_lte_info: cashRewardLteInfo,
				fission_page_ab: fissionPageAb,
				first_invite_by_day: firstInviteByDay,
			} = data;
			const info = {
				posterMsg: {
					inviteCode,
					name: nickname,
				},
				inviteInfo,
				cashReward: {
					invitedUser: Object.values(invitedUser),
					show,
					title,
					subtitle,
					fissionStatus,
					notRewardNum,
				},
				task,
				diagram,
				weChatNum,
				shareAB: shareAB || 'c',
				shareTxt: shareTxt || '',
				cycleReward,
				limitRewardAB: limitRewardAB || -1,
				cashRewardLteInfo,
				fissionPageAb,
			};

			if (cashRewardLteInfo) {
				info.remainTime = cashRewardLteInfo.task_info ? cashRewardLteInfo.task_info.ttl || 0 : 0;
			}

			state.pageInfo = info;
			state.firstInviteByDay = firstInviteByDay;
		},
		setRecordPageInfo(state, data) {
			const {
				earned_count,
				to_be_earned_count,
				userinfo: { invite_code: inviteCode, nickname },
				my_reward: { direct, indirect },
			} = data;
			state.recordPageInfo = {
				myReward: {
					earned: earned_count,
					toBeEarned: to_be_earned_count,
					direct: direct || {},
					indirect: indirect || {},
				},
				posterMsg: {
					inviteCode,
					name: nickname,
				},
			};
		},
		setFissionModal(state, data) {
			state.modal = Object.assign(state.modal, data);
		},
		setLeaveWay(state, data) {
			state.leaveWay = Object.assign(state.leaveWay, data);
		},
		setRemainTime(state, data) {
			state.pageInfo.remainTime = data;
		},
		setMistiming(state, data) {
			state.mistiming = data;
		},
		setCountdown(state) {
			let mistiming = state.firstInviteByDay.count_down;
			mistiming -= 1;
			Vue.set(state.firstInviteByDay, 'count_down', mistiming);
			let countDownHours = Math.floor((mistiming / 60 / 60) % 24); // 获取小时
			let countDownMinutes = Math.floor((mistiming / 60) % 60);
			let countDownSeconds = Math.floor(mistiming % 60);
			// 判断天、时、分、秒是不是两位数，如果是直接输出，如果不是在前边加个0;
			countDownHours < 10 ? (countDownHours = '0' + countDownHours) : countDownHours;
			countDownMinutes < 10 ? (countDownMinutes = '0' + countDownMinutes) : countDownMinutes;
			countDownSeconds < 10 ? (countDownSeconds = '0' + countDownSeconds) : countDownSeconds;
			state.firstInviteCountDown = {
				countDownHours,
				countDownMinutes,
				countDownSeconds,
			};
		},
		setFirstInviteCountDownShow(state, data) {
			Vue.set(state.firstInviteByDay, 'is_valid', data);
		},
	},
	actions: {},
	getters: {
		getPosterMsgData(state) {
			return state.pageInfo.posterMsg;
		},
		getMyRewardData(state) {
			return state.pageInfo.inviteInfo;
		},
		getCashRewardData(state) {
			return state.pageInfo.cashReward;
		},
		getTaskData(state) {
			return state.pageInfo.task;
		},
		getDiagramData(state) {
			return state.pageInfo.diagram;
		},
		getChatNumData(state) {
			return state.pageInfo.weChatNum;
		},
		getRecordRewardData(state) {
			return state.recordPageInfo.myReward;
		},
		getRecordPosterMsgData(state) {
			return state.recordPageInfo.posterMsg;
		},
		modal(state) {
			return state.modal;
		},
		leaveWay(state) {
			return state.leaveWay;
		},
		shareAB(state) {
			return state.pageInfo.shareAB;
		},
		shareTxt(state) {
			return state.pageInfo.shareTxt;
		},
		cycleReward(state) {
			return state.pageInfo.cycleReward;
		},
		limitRewardAB(state) {
			return state.pageInfo.limitRewardAB;
		},
		cashRewardLteInfo(state) {
			return state.pageInfo.cashRewardLteInfo;
		},
		remainTime(state) {
			return state.pageInfo.remainTime;
		},
		mistiming(state) {
			return state.firstInviteByDay.count_down;
		},
		firstInviteCountDown(state) {
			return state.firstInviteCountDown;
		},
		firstInviteByDay(state) {
			return state.firstInviteByDay;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Fission/index.js